const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const pricingHistory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PRICING_HISTORY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_PRICING_HISTORY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default pricingHistory;